import "./SearchPage.scss";

export default {
  root: "im-search-page",
  form: "im-search-page__form",
  formV2: "im-search-page__form--v2",
  resultsSummary: "im-search-page__results-summary",
  resultsHeader: "im-search-page__results-header",
  searchFilters: "im-search-page__search-filters",
};
